"use client"

import { useEffect, useState, useCallback } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter } from "../../lib/tenant"
import "../../styles/DisciplinaList.css"

export default function DisciplinaList({ keyProp, onEdit }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [disciplinas, setDisciplinas] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchDisciplinas = useCallback(async () => {
    setLoading(true)
    try {
      let query = supabase.from("disciplinas").select("*").order("nome", { ascending: true })
      
      query = applyInstitutionFilter(query, isAdmin, instituicaoId)
      const { data, error } = await query

      if (error) throw error
      setDisciplinas(data || [])
    } catch (err) {
      console.error("Erro ao buscar disciplinas:", err.message)
    } finally {
      setLoading(false)
    }
  }, [isAdmin, instituicaoId])

  useEffect(() => {
    fetchDisciplinas()
  }, [keyProp, fetchDisciplinas])

  const handleDelete = async (disciplina) => {
    if (!window.confirm(`Tem certeza que deseja excluir a disciplina "${disciplina.nome}"?`)) {
      return
    }

    try {
      // Remover associações com turmas
      const { error: tdError } = await supabase.from("turma_disciplina").delete().eq("disciplina_id", disciplina.id)

      if (tdError) {
        console.error("Erro ao deletar turma_disciplina:", tdError)
      }

      // Remover associações com professores
      const { error: pdError } = await supabase.from("professor_disciplina").delete().eq("disciplina_id", disciplina.id)

      if (pdError) {
        console.error("Erro ao deletar professor_disciplina:", pdError)
      }

      // Remover de horários
      const { error: horariosError } = await supabase
        .from("horarios")
        .update({ disciplina_id: null })
        .eq("disciplina_id", disciplina.id)

      if (horariosError) {
        console.error("Erro ao atualizar horarios:", horariosError)
      }

      // Deletar disciplina
      const { error } = await supabase.from("disciplinas").delete().eq("id", disciplina.id)

      if (error) throw error

      alert("Disciplina excluída com sucesso!")
      fetchDisciplinas()
    } catch (err) {
      console.error("Erro ao excluir disciplina:", err.message)
      alert("Erro ao excluir disciplina: " + err.message)
    }
  }

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Carregando disciplinas...</p>
      </div>
    )
  }

  if (!disciplinas.length) {
    return (
      <div className="empty-state">
        <p>Nenhuma disciplina cadastrada.</p>
      </div>
    )
  }

  return (
    <div className="disciplina-list-container">
      <h3 className="list-title">Disciplinas Cadastradas</h3>

      <div className="cards-grid">
        {disciplinas.map((d) => (
          <div key={d.id} className="disciplina-card">
            <div className="card-header">
              <h3 className="disciplina-nome">{d.nome}</h3>
              <span className="disciplina-codigo">{d.codigo}</span>
            </div>

            <div className="card-body">
              {d.tipo && (
                <div className="info-row">
                  <span className="info-label">Tipo:</span>
                  <span className="info-value">
                    {d.tipo === "N" ? "Nuclear" : d.tipo === "C" ? "Complementar" : "Gerais"}
                  </span>
                </div>
              )}
            </div>

            <div className="card-actions">
              <button className="btn-editar" onClick={() => onEdit && onEdit(d)}>
                Editar
              </button>
              <button className="btn-excluir" onClick={() => handleDelete(d)}>
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
